import {
  costCenterToolTipMsg,
  emailWorkMsg,
  firstNameMsg,
  lastNameMsg,
  mobilePhoneNumberWorkMsg,
  referenceToolTipMsg,
  t,
} from '../../i18n';
import { FormGridFieldset } from '../FormGridFieldset/FormGridFieldset';
import { Email, Name, PhoneNumber } from '../fields';
import { CostCenter } from '../fields/CostCenter';
import { Reference } from '../fields/Reference';

export interface ContactFieldsetValues {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  costCenter: string;
  employeeNumber: string;
}

interface ContactFieldsetProps {
  readonly: boolean;
}

export const ContactFieldset = ({ readonly }: ContactFieldsetProps) => {
  const placeholder = readonly ? '-' : '';
  return (
    <FormGridFieldset>
      <Name name="firstName" label={t.AIK7(firstNameMsg)} placeholder={placeholder} readonly={readonly} />
      <Name name="lastName" label={t.Y41S(lastNameMsg)} placeholder={placeholder} readonly={readonly} />
      <PhoneNumber label={t.V9K9(mobilePhoneNumberWorkMsg)} placeholder={placeholder} readonly={readonly} />
      <Email label={t.JYZO(emailWorkMsg)} placeholder={placeholder} readonly={readonly} />
      <CostCenter tooltip={`${t.UE8R(costCenterToolTipMsg)}`} placeholder={placeholder} readonly={readonly} />
      <Reference tooltip={t.HBBD(referenceToolTipMsg)} placeholder={placeholder} readonly={readonly} />
    </FormGridFieldset>
  );
};
